import initAjaxSelect2 from "../services/init-ajax-select2"

export default () => ({
    selectedCourse: 0,
    selectedEmployees: [],
    selectedDivision: 0,
    userId: 0,
    assignToDivision: false,
    deadline: null,
    isLoading: false,
    isReassigning: false,
    results: [],
    isReassignAll: false,
    autoAssign: false,
    monthInterval: 1,
    iterationsTotal: 1,
    autoAssignDeadline: 1,

    init () {
        this.userId = this.$root.dataset.currentUserId
        const { url, nonce } = rozetka_learnpress_global.restApi

        try {
            jQuery(document).ready(() => {
                this.select2Courses = jQuery('#course').select2(initAjaxSelect2(
                    `${url}courses`,
                    { user_id: this.userId, mode: 'assign' },
                    nonce
                ));
                this.select2Employees = jQuery('#employee').select2(initAjaxSelect2(
                    `${url}employees`,
                    { user_id: this.userId },
                    nonce
                ));
                this.select2Divisions = jQuery('#division').select2(initAjaxSelect2(
                    `${url}divisions`,
                    { user_id: this.userId },
                    nonce
                ));

                const multiSelect2EventListener = (event) => {
                    const values = [];

                    jQuery(event.currentTarget).find("option:selected").each(function(i, selected){
                        values.push(parseInt(jQuery(selected).val()))
                    })

                    this.selectedEmployees = values
                }

                this.select2Employees.on("select2:select", multiSelect2EventListener)
                this.select2Employees.on("select2:unselect", multiSelect2EventListener)

                this.select2Courses.on("select2:select", (event) => {
                    this.selectedCourse = event.target.value
                })
                this.select2Divisions.on("select2:select", (event) => {
                    this.selectedDivision = event.target.value
                })

                this.$watch("selectedCourse", (value) => {
                    this.select2Courses.val(value).trigger("change")
                })
                this.$watch("selectedDivision", (value) => {
                    this.select2Divisions.val(value).trigger("change")
                })
            })
        } catch (error) {
            console.error(error)
        }
    },

    async submitForm() {
        try {
            if (!this.validate()) {
                return
            }

            this.isLoading = true;

            let url = rozetka_learnpress_global.restApi.url
            let body = {
                courseId: this.$store?.AssignFormStore?.selectedCourse,
                deadline: this.deadline,
                autoAssign: this.autoAssign,
                monthInterval: this.monthInterval,
                iterationsTotal: this.iterationsTotal,
                autoAssignDeadline: this.autoAssignDeadline,

            }

            if (this.assignToDivision) {
                url += 'assign-course-to-division';
                body.divisionId = this.$store?.AssignFormStore?.selectedDivisions[0];
            } else {
                url += 'assign-course-to-employees';
                body.employeeIds = this.selectedEmployees;
            }

            const response = await this.fetchPost(url, body)

            if (!response.success) throw new Error(response.message);

            if (this.autoAssign) {
                this.results.push({
                    success: response.success,
                    msg: response.message,
                    employeeName: response.info,
                    visibility: true,
                });
            } else {
                this.isReassignAll = !response.isSuccessAll

                for (const key in response.data) {
                    const result = response.data[key]
                    this.results.push({
                        success: result.success,
                        msg: result.message,
                        employeeName: result.employeeName,
                        userId: result.userId,
                        visibility: true
                    })
                }
            }

            this.reset();
        } catch (error) {
            console.error(error)
            this.results.push({
                success: false,
                msg: error
            })
        } finally {
            this.isLoading = false;
        }
    },

    async reassign(userId) {
        try {
            this.isReassigning = true

            const response = await this.fetchPost(rozetka_learnpress_global.restApi.url + 'reassign-course-to-user', {
                courseId: this.$store?.AssignFormStore?.selectedCourse,
                deadline: this.deadline,
                userId
            })

            if (!response.success) throw new Error(response.message)

            this.findAndUpdateResult(response.data)
        } catch (error) {
            console.error(error)
        } finally {
            this.isReassigning = false
        }
    },

    async reassignAll() {
        try {
            this.isReassigning = true

            const userIds = []

            for (const [key, result] in this.results) {
                if (!this.results[key].success) {
                    userIds.push(this.results[key].userId)
                }
            }

            const response = await this.fetchPost(rozetka_learnpress_global.restApi.url + 'assign-course-to-users', {
                courseId: this.$store?.AssignFormStore?.selectedCourse,
                deadline: this.deadline,
                userIds,
                reassign: true
            })

            if (!response.success) throw new Error(response.message)

            this.isReassignAll = !response.isSuccessAll

            for (const key in response.data) {
                this.findAndUpdateResult(response.data[key])
            }


        } catch (error) {
            console.error(error)
        } finally {
            this.isReassigning = false
        }
    },

    findAndUpdateResult({success, userId, message}) {
        for (const [key, result] in this.results) {
            if (this.results[key].userId === userId) {
                this.results[key].success = success
                this.results[key].msg = message
            }
        }
    },

    reset(withResults = false) {
        this.selectedCourse = 0;
        this.selectedDivision = 0;
        this.selectedEmployees = [];
        this.deadline = null;
        this.$store.AssignFormStore.selectedCourse = 0;
        this.$store.AssignFormStore.selectedDivisions = [];

        if (withResults) {
            this.results = [];
        }
    },

    validate() {
        let valid = true
        const errors = []

        if (this.$store?.AssignFormStore?.selectedCourse === 0) {
            valid = false
            errors.push(rozetka_learnpress_global.errorMessages.courseFieldIsRequired)
        }

        if (!this.selectedEmployees.length && !this.assignToDivision) {
            valid = false
            errors.push(rozetka_learnpress_global.errorMessages.employeesFieldIsRequired)
        }

        if (!this.$store?.AssignFormStore?.selectedDivisions[0] && this.assignToDivision) {
            valid = false
            errors.push(rozetka_learnpress_global.errorMessages.divisionFieldIsRequired)
        }
        if (!this.deadline && !this.autoAssign) {
            valid = false
            errors.push(rozetka_learnpress_global.errorMessages.deadlineFieldIsRequired)
        }

        if (!valid) {
            alert(errors.join("\r\n"))
        }

        return valid
    },

    async fetchPost(url, body = {}) {
        const response = await fetch(url,
            {
                method: 'POST',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                    "X-WP-Nonce": rozetka_learnpress_global.restApi.nonce
                },
                body: JSON.stringify(body)
            })

        return await response.json()
    },

    searchResultInputHandler(event) {
        this.filterEmployees(event.target.value)
    },

    filterEmployees(searchTerm) {
        const lowerSearch = searchTerm.toLowerCase()
        this.results = this.results.map(emp => ({
            ...emp,
            visibility: emp.employeeName.toLowerCase().includes(lowerSearch)
        }))
    }
})